export class EndoInvModel {
endoinvcode = '' ;
endoinvdate = '2022-01-01' ;
endoinv = '' ;
endoinvtype = '' ;
endoinvsite = '' ;
endoinvgrade = '' ;
endoinvt = '' ;
endoinvn = '' ;
endoinvcomm = '' ;

endoinvdate1 = '2022-01-01' ;

getfrom = '' ;
visitdate = '2022-01-01' ;
source = '' ;
compcode = '1' ;
userid = 'sa' ;
modifieddate = '2022-01-01' ;

}
export class EndoTypeModel {
endotypecode = '' ;
endotypename = '' ;
endotypenotes = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;

}
